function EUMAApage() {  return (
    <>
      <div className="flex items-center gap-2 mb-6">
        <span className="w-4 h-4 rounded-full bg-sky-300 flex-shrink-0"></span>
        <h3 className="text-lg font-bold text-[#05326D]">
          2. EU-MAA – Marketing Authorization Application
        </h3>
      </div>

      <p className="text-md font-bold text-[#05326D] mb-4">
        Region: European Union
      </p>
      <p className="text-[#05326D] mt-2">Purpose: Approval of new or generic drugs </p>

      <p className="text-[#05326D] mb-4 mt-2">Body: EMA or national agencies via CP, MRP, DCP, NP</p>


      <p className="text-md font-bold text-[#05326D] mb-4">
        Key Components:
      </p>
      <p className="ml-2 mt-2 text-[#05326D]">- Module 1–5 in CTD format</p>
      <p className="ml-2 mt-2 text-[#05326D]">- ASMF or CEP references for APIs</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Risk management plans (RMP)</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Environmental risk assessments (ERA)</p>


      <p className="text-md font-bold text-[#05326D] mb-4 mt-4">
        Filing Notes: </p>

      <p className="ml-2 mt-2 text-[#05326D]">- Submitted via CESP portal</p>
      <p className="ml-2 mt-2 text-[#05326D]">- ASMF includes Applicant’s Part (AP) and Restricted Part (RP)</p>
      <p className="ml-2 mt-2 text-[#05326D]">- CEP must be approved by EDQM before referencing</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Variations and renewals managed via Type IA, IB, II procedures</p>




      <hr className="border-t border-gray-300 mb-8 mt-8" />
      <p className="text-md font-bold text-[#05326D] mb-4 mt-4">
        Strategic Tip from FDAC: </p>

      <p className="text-[#05326D]">For global dossier success, FDAC recommends:</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Early alignment of DMF/ASMF/CEP with target market requirements</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Robust eCTD publishing and validation workflows</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Lifecycle planning for post-approval changes and renewals</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Cloud-based collaboration for real-time dossier management</p>
    </>

  );
}

export default EUMAApage;
